export { default } from './ClientTile';



// WEBPACK FOOTER //
// ./src/components/atoms/ClientTile/index.js